import { Shipment, ShipmentDeliveryNote } from '../models';

export class ShipmentDeliveryNoteDto {
  uuid: string;
  customerPrice: number;
  fleetPrice: number;
  priceComment: string;
  deliveryNoteNumber: string;
  multiDestinationCharge: number;
  returnCharge: number;
  detentionCharge: number;
  customerWaitingChargePerDay: string;
  fleetWaitingCharge: number;
  customerReturnCharge: number;
  fleetReturnCharge: number;
  multiDestinationChargeCost: number;
  multiDestinationChargePrice: number;
  customerClearanceFees: number;
  weightingFine: number;
  fleetClearanceFees: number;
  fleetWeightingFine: number;
  damageCost: number;
  advancedPayment: number;
  waitingDays: number;
  waitingChargeProfId: number;
  deliveryNotes: {
    id: number;
    referenceNumber: number;
    mediaId: number | null;
  }[];
  deliveryNoteComment: string;

  constructor(shipment: Shipment) {
    this.uuid = shipment.uuid;
    this.customerPrice = shipment.transactions[0]?.customerPrice || 0;
    this.fleetPrice = shipment.transactions[0]?.fleetPrice || 0;
    this.priceComment = shipment.priceComment;
    this.deliveryNoteNumber = shipment.deliveryNoteNumber;
    this.multiDestinationCharge = shipment.multiDestinationCharge;
    this.returnCharge = shipment.returnCharge;
    this.detentionCharge = shipment.detentionCharge;
    this.customerWaitingChargePerDay = shipment.transactions[0]?.customerWaitingChargePerDay || '0';
    this.fleetWaitingCharge = shipment.transactions[0]?.fleetWaitingCharge || 0;
    this.customerReturnCharge = shipment.transactions[0]?.customerReturnCharge || 0;
    this.fleetReturnCharge = shipment.transactions[0]?.fleetReturnCharge || 0;
    this.multiDestinationChargeCost = shipment.transactions[0]?.multiDestinationChargeCost || 0;
    this.multiDestinationChargePrice = shipment.transactions[0]?.multiDestinationChargePrice || 0;
    this.customerClearanceFees = shipment.transactions[0]?.customerClearanceFees || 0;
    this.weightingFine = shipment.transactions[0]?.weightingFine || 0;
    this.fleetClearanceFees = shipment.transactions[0]?.fleetClearanceFees || 0;
    this.fleetWeightingFine = shipment.transactions[0]?.fleetWeightingFine || 0;
    this.damageCost = shipment.transactions[0]?.damageCost || 0;
    this.advancedPayment = shipment.transactions[0]?.advancedPayment || 0;
    this.waitingDays = shipment.transactions[0]?.waitingDays || 0;
    this.waitingChargeProfId = shipment.waitingChargeProfId;

    this.deliveryNotes =
      shipment.deliveryNote
        ?.filter((d: ShipmentDeliveryNote) => d.referenceNumber)
        ?.map((d: ShipmentDeliveryNote) => ({
          id: d.id,
          referenceNumber: d.referenceNumber,
          mediaId: d.attachment?.id || null,
        })) || [];

    this.deliveryNoteComment = shipment.deliveryNoteComment;
  }
}
